import request from '@/utils/request'
/**
 * 色板列表
 */
export function getColorBoardList(data) {
  return request({
    url: 'api/getColorBoardList',
    method: 'post',
    params: data
  })
}

export function getSwatch(data) {
  return request({
    url: 'oper/getSwatch',
    method: 'post',
    params: data
  })
}

export function updateOrAddSwatch(data) {
  return request({
    url: 'oper/updateOrAddSwatch',
    method: 'post',
    params: data
  })
}

export function deleteSwatch(data) {
  return request({
    url: 'oper/deleteSwatch',
    method: 'post',
    params: data
  })
}
